module.exports = __webpack_public_path__ + "img/everyBody_01.3154b7aa.png";